var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isDetailView)?_c('v-container',[_c('sr-breadcrumbs',{attrs:{"items":[{text: 'Home',to:{name: 'Home'} }, {text: 'Frameworks', to:{name: 'AllFrameworks'}, disabled: true}]}}),(_vm.isAuthor)?_c('v-row',[_c('v-col',[_c('create-framework')],1)],1):_vm._e(),_c('v-row',[_c('v-col',[_c('framework-widget')],1)],1)],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }